export default [
  {
    path: '/payment/settings',
    name: 'payment.settings',
    component: () => import('views/private/payment/settings/PaymentSettings'),
    redirect: {
      name: 'payment.settings.form',
    },
    children: [
      {
        path: '',
        name: 'payment.settings.form',
        component: () => import('organisms/payment/settings/PaymentFormSettings'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'methods',
        name: 'payment.settings.method',
        component: () => import('organisms/payment/settings/PaymentMethodsSettings'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'technical',
        name: 'payment.settings.technical',
        component: () => import('organisms/payment/settings/PaymentTechnicalSettings'),
        meta: {
          requiresAuth: true,
        },
      },
    ],
  },
];
